import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	padding-right: 32px;
`;

export const HeaderRow = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 16px;
`;

export const HeaderLabel = styled.div`
	font-weight: 400;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
`;

export const FilterWrapper = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	padding-bottom: 16px;
`;

export const ChipWrapper = styled.div`
	display: flex;
	padding-bottom: 24px;

	div > span {
		text-transform: none;
	}
`;

export const DropdownWrapper = styled.div`
	width: 100%;
	overflow: hidden;
`;

export const DropdownLabel = styled.div`
	font-weight: 400;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey8};
	min-width: 150px;
	padding-right: 16px;
`;

export const LoadingWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;
